import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.LSTT_LIST_API,
    formData
  )

  return handleRequest(request);
}

function* lichSuThanhToanListRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.lichSuThanhToanListSuccess(results.data))

  } catch (error) {
    yield put(brActions.lichSuThanhToanListError(error))
  }
}

function lichSuThanhToanRemoveRequestApi(formData) {
  const request = axiosApi().post(
    Constants.LSTT_REMOVE_API,
    formData
  )
  return handleRequest(request);
}

function* lichSuThanhToanRemoveRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const result = yield call(lichSuThanhToanRemoveRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.lichSuThanhToanRemoveSuccess(result));
    if (typeof callback == 'function') {
      yield call(callback, result.data);
    }
  } catch (error) {
    yield put(brActions.lichSuThanhToanRemoveError(error))
  }
}

function exportXlsRequestApi(formData) {
  const url = `${Constants.LSTT_EXPORT_API  }?Loai=${  formData.Loai != '' ? formData.Loai : 0  }&ObjectId=${  formData.ObjectId  }&TuNgay=${  formData.TuNgay  }&DenNgay=${  formData.DenNgay }&page=${  formData.page  }&per_page=${  formData.per_page  }&Keyword=${  formData.Keyword}`;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* lichSuThanhToanExportXlsRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, payload)
    // dispatch the action with our widgets!
    yield put(brActions.lichSuThanhToanExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(brActions.lichSuThanhToanExportXlsError(error))
  }
}

function* lichSuThanhToanWatcher() {
  yield [
    takeLatest(Constants.LSTT_LIST_REQUESTING, lichSuThanhToanListRequestFlow),
    takeLatest(Constants.LSTT_REMOVE_REQUESTING, lichSuThanhToanRemoveRequestFlow),
    takeLatest(Constants.LSTT_EXPORT_XLS_REQUESTING, lichSuThanhToanExportXlsRequestFlow),
  ]
}

export default lichSuThanhToanWatcher



// WEBPACK FOOTER //
// ./src/views/LichSuThanhToan/sagas.js